function ValidateEmail(inputText) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputText.value.match(mailformat)) {
      return true;
    } else {
      return false;
    }
  }

  import { BuyButtons } from 'theme';

  class ExtendedBuyButtons extends BuyButtons {
      constructor() {
          super();
          this.variantTitle = null;
          this.variantId = null;
          this.productId = null;
      }
  
      connectedCallback() {
          super.connectedCallback();
          document.addEventListener("variant:change", this.handleVariantChange);
          if(this.querySelector('.notify-back')){
          this.querySelector('.notify-back').addEventListener('click', this.handleClick);}
       //   this.backInStock(null, false);
      }
  
      disconnectedCallback() {
          document.removeEventListener("variant:change", this.handleVariantChange);
          if(this.querySelector('.notify-back')){
          this.querySelector('.notify-back').removeEventListener('click', this.handleClick);
          }
      }
  
      handleVariantChange = (event) => {
         // this.backInStock(event.detail, false); 
      }
  
      handleClick = (event) => {
        //  this.backInStock(null, true);
      }
  
      updatePropertiesFromEvent(event) {
          this.variantTitle = event.variant.name;    
          this.variantId = event.variant.id;
          this.productId = event.product.id;
      }
  
      updatePropertiesFromJson(jsonData) {
          this.variantTitle = jsonData.selected_variant.name; 
          this.variantId = jsonData.selected_variant.id;
          this.productId = jsonData.product.id;
          this.variantTitle = jsonData.selected_variant.name; 
      }
  
      backInStock(event, submit) {
          let userEmail = this.querySelector('.BackInStock input');
          let label = this.querySelector('.BackInStock .floating-label');
          let jsonData;
  
          try {
              jsonData = JSON.parse(this.querySelector('[data-product-json]').innerHTML);
          } catch (error) {
              console.error('Error parsing JSON', error);
              return;
          }
  
          if (event) {
              console.log(event);
              this.updatePropertiesFromEvent(event);
          } else {
              this.updatePropertiesFromJson(jsonData);
          }
  
          if (submit) {
              if (ValidateEmail(userEmail)) {
                  this.subscribeUser(userEmail, label);
              } else {
                  this.updateUIForInvalidEmail(label);
              }
          }
      }
  
      subscribeUser(userEmail, label) {
          fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
              headers: {
                  "accept": "application/json, text/plain, */*",
                  "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
              },
              body: new URLSearchParams({
                  "a": "SvUdDz",
                  "email": userEmail.value,
                  "platform": "shopify",
                  "variant": this.variantId,
                  "product": this.productId,
              }),
              method: "POST",
          })
          .then(response => {
              if (response.ok) {
                  this.updateUIForSuccess(label, userEmail);
              } else {
                  this.updateUIForInvalidEmail(label);
              }
          })
          .catch(error => {
              console.error('Fetch error:', error);
              this.updateUIForNetworkError(label);
          });
      }
  
      updateUIForSuccess(label, userEmail) {
          label.classList.add('subscribed');
          label.classList.remove('alert');
          userEmail.classList.add('subscribed');
          label.innerText = 'Subscribed: ' + this.variantTitle;
          this.querySelector('.notify-back').innerText = 'Subscribed';
      }
  
      updateUIForInvalidEmail(label) {
          label.classList.add('alert');
          label.classList.remove('subscribed');
          label.style.opacity = "1";
          label.innerText = 'Please enter a valid email';
      }
  
      updateUIForNetworkError(label) {
          label.classList.add('alert');
          label.innerText = 'Network error, try again later';
      }
  }
  
  if (!window.customElements.get("buy-buttons-extended")) {
      window.customElements.define("buy-buttons-extended", ExtendedBuyButtons);
  }
  
  document.addEventListener("DOMContentLoaded", function() {
    // Define the font family you want to apply
    const fontFamily = "Helvetica";

    // Regular expression to find currency patterns (e.g., $123.45, 123.45€, etc.)
    const currencyRegex = /((?:\$|\€|\£|\¥|\₹|\%)\d+(?:\.\d{2})?|\d+(?:\.\d{2})?(?:\$|\€|\£|\¥|\₹|\%))/g;

    // Function to wrap text in a span with a specific font family
    function wrapWithFontFamily(text) {
        return `<span style="font-family: ${fontFamily};">${text}</span>`;
    }

    // Function to find and replace currency patterns in a text node
    function replaceCurrencyInTextNode(textNode) {
        const originalText = textNode.nodeValue;
        if (currencyRegex.test(originalText)) {
            const newText = originalText.replace(currencyRegex, match => wrapWithFontFamily(match));
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newText;
            while (tempDiv.firstChild) {
                textNode.parentNode.insertBefore(tempDiv.firstChild, textNode);
            }
            textNode.parentNode.removeChild(textNode);
        }
    }

    // Traverse the DOM to find text nodes and apply the replacement
    function traverseAndReplace(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            replaceCurrencyInTextNode(node);
        } else {
            for (let childNode of node.childNodes) {
                traverseAndReplace(childNode);
            }
        }
    }

    // Start traversing from the body element
    var announcement_bar = document.querySelector('.shopify-section--announcement-bar')
    traverseAndReplace(announcement_bar);
});